import { assert } from '@ember/debug';
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';
import BasicRadioGroup, {
  type Signature as BasicRadioGroupComponentSignature
} from './basic-radio-group.gts';

export interface Signature {
  Element: HTMLDivElement;
  Args: Pick<
    BasicRadioGroupComponentSignature['Args'],
    | 'current'
    | 'isReadOnly'
    | 'title'
    | 'propertyName'
    | 'isMandatory'
    | 'displaySubText'
    | 'subText'
  > & {
    onChange?: () => void;
  };
  Blocks: {
    default: [group: BasicRadioGroupComponentSignature['Blocks']['default'][0]];
  };
}

/**
 * A component with a label and radio buttons.
 * Label and buttons are displayed as block, radio buttons are inlined.
 */
export default class AlignedFieldsRadioGroupComponent extends Component<Signature> {
  ensureFieldParent = modifier(function (element: HTMLDivElement) {
    assert(
      `The component 'aligned-fields-radio-group-component' must be a direct child of a 'field' element in the DOM`,
      (element.parentElement as HTMLElement).classList.contains('field')
    );
  });

  <template>
    <BasicRadioGroup
      @current={{@current}}
      @onChange={{@onChange}}
      @isReadOnly={{@isReadOnly}}
      @title={{@title}}
      @propertyName={{@propertyName}}
      @displaySubText={{@displaySubText}}
      @subText={{@subText}}
      @isMandatory={{@isMandatory}}
      as |group|
    >
      <div
        class='fields [.ui.form_&.fields]:mb-0 [.ui.form_&.fields_.field+.field]:ml-[2em]'
        ...attributes
        {{this.ensureFieldParent}}
      >

        {{yield group}}
      </div>
    </BasicRadioGroup>
  </template>
}
